/**
 * Forms marked `data-auto-submit` have no submit button: they are custom selects
 * (filters, sort order) that reload the listing as soon as an option is picked.
 * The custom select dispatches a `change` event on its hidden input, which bubbles
 * up to the form.
 */
export default class AutoSubmit {
  static init() {
    document.querySelectorAll('form[data-auto-submit]').forEach((form) => {
      form.addEventListener('change', () => form.submit());
    });
  }
}
